export type FontsProps = {
  publicPath: string
}

export const Fonts = ({ publicPath }: FontsProps) => {
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
/* open-sans-300 - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  src: url('${publicPath}/fonts/open-sans-v34-latin-300.eot');
  src: local(''), url('${publicPath}/fonts/open-sans-v34-latin-300.eot?#iefix') format('embedded-opentype'),
    url('${publicPath}/fonts/open-sans-v34-latin-300.woff2') format('woff2'),
    url('${publicPath}/fonts/open-sans-v34-latin-300.woff') format('woff'),
    url('${publicPath}/fonts/open-sans-v34-latin-300.ttf') format('truetype'),
    url('${publicPath}/fonts/open-sans-v34-latin-300.svg#OpenSans') format('svg');
  font-display: swap;
}
/* open-sans-regular - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  src: url('${publicPath}/fonts/open-sans-v34-latin-regular.eot');
  src: local(''), url('${publicPath}/fonts/open-sans-v34-latin-regular.eot?#iefix') format('embedded-opentype'),
    url('${publicPath}/fonts/open-sans-v34-latin-regular.woff2') format('woff2'),
    url('${publicPath}/fonts/open-sans-v34-latin-regular.woff') format('woff'),
    url('${publicPath}/fonts/open-sans-v34-latin-regular.ttf') format('truetype'),
    url('${publicPath}/fonts/open-sans-v34-latin-regular.svg#OpenSans') format('svg');
  font-display: swap;
}
/* open-sans-500 - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 500;
  src: url('${publicPath}/fonts/open-sans-v34-latin-500.eot');
  src: local(''), url('${publicPath}/fonts/open-sans-v34-latin-500.eot?#iefix') format('embedded-opentype'),
    url('${publicPath}/fonts/open-sans-v34-latin-500.woff2') format('woff2'),
    url('${publicPath}/fonts/open-sans-v34-latin-500.woff') format('woff'),
    url('${publicPath}/fonts/open-sans-v34-latin-500.ttf') format('truetype'),
    url('${publicPath}/fonts/open-sans-v34-latin-500.svg#OpenSans') format('svg');
  font-display: swap;
}
/* open-sans-600 - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  src: url('${publicPath}/fonts/open-sans-v34-latin-600.eot');
  src: local(''), url('${publicPath}/fonts/open-sans-v34-latin-600.eot?#iefix') format('embedded-opentype'),
    url('${publicPath}/fonts/open-sans-v34-latin-600.woff2') format('woff2'),
    url('${publicPath}/fonts/open-sans-v34-latin-600.woff') format('woff'),
    url('${publicPath}/fonts/open-sans-v34-latin-600.ttf') format('truetype'),
    url('${publicPath}/fonts/open-sans-v34-latin-600.svg#OpenSans') format('svg');
  font-display: swap;
}
/* open-sans-700 - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  src: url('${publicPath}/fonts/open-sans-v34-latin-700.eot');
  src: local(''), url('${publicPath}/fonts/open-sans-v34-latin-700.eot?#iefix') format('embedded-opentype'),
    url('${publicPath}/fonts/open-sans-v34-latin-700.woff2') format('woff2'),
    url('${publicPath}/fonts/open-sans-v34-latin-700.woff') format('woff'),
    url('${publicPath}/fonts/open-sans-v34-latin-700.ttf') format('truetype'),
    url('${publicPath}/fonts/open-sans-v34-latin-700.svg#OpenSans') format('svg');
  font-display: swap;
}
/* open-sans-800 - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 800;
  src: url('${publicPath}/fonts/open-sans-v34-latin-800.eot');
  src: local(''), url('${publicPath}/fonts/open-sans-v34-latin-800.eot?#iefix') format('embedded-opentype'),
    url('${publicPath}/fonts/open-sans-v34-latin-800.woff2') format('woff2'),
    url('${publicPath}/fonts/open-sans-v34-latin-800.woff') format('woff'),
    url('${publicPath}/fonts/open-sans-v34-latin-800.ttf') format('truetype'),
    url('${publicPath}/fonts/open-sans-v34-latin-800.svg#OpenSans') format('svg');
  font-display: swap;
}
/* open-sans-300italic - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 300;
  src: url('${publicPath}/fonts/open-sans-v34-latin-300italic.eot');
  src: local(''), url('${publicPath}/fonts/open-sans-v34-latin-300italic.eot?#iefix') format('embedded-opentype'),
    url('${publicPath}/fonts/open-sans-v34-latin-300italic.woff2') format('woff2'),
    url('${publicPath}/fonts/open-sans-v34-latin-300italic.woff') format('woff'),
    url('${publicPath}/fonts/open-sans-v34-latin-300italic.ttf') format('truetype'),
    url('${publicPath}/fonts/open-sans-v34-latin-300italic.svg#OpenSans') format('svg');
  font-display: swap;
}
/* open-sans-italic - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 400;
  src: url('${publicPath}/fonts/open-sans-v34-latin-italic.eot');
  src: local(''), url('${publicPath}/fonts/open-sans-v34-latin-italic.eot?#iefix') format('embedded-opentype'),
    url('${publicPath}/fonts/open-sans-v34-latin-italic.woff2') format('woff2'),
    url('${publicPath}/fonts/open-sans-v34-latin-italic.woff') format('woff'),
    url('${publicPath}/fonts/open-sans-v34-latin-italic.ttf') format('truetype'),
    url('${publicPath}/fonts/open-sans-v34-latin-italic.svg#OpenSans') format('svg');
  font-display: swap;
}
/* open-sans-500italic - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 500;
  src: url('${publicPath}/fonts/open-sans-v34-latin-500italic.eot');
  src: local(''), url('${publicPath}/fonts/open-sans-v34-latin-500italic.eot?#iefix') format('embedded-opentype'),
    url('${publicPath}/fonts/open-sans-v34-latin-500italic.woff2') format('woff2'),
    url('${publicPath}/fonts/open-sans-v34-latin-500italic.woff') format('woff'),
    url('${publicPath}/fonts/open-sans-v34-latin-500italic.ttf') format('truetype'),
    url('${publicPath}/fonts/open-sans-v34-latin-500italic.svg#OpenSans') format('svg');
  font-display: swap;
}
/* open-sans-600italic - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 600;
  src: url('${publicPath}/fonts/open-sans-v34-latin-600italic.eot');
  src: local(''), url('${publicPath}/fonts/open-sans-v34-latin-600italic.eot?#iefix') format('embedded-opentype'),
    url('${publicPath}/fonts/open-sans-v34-latin-600italic.woff2') format('woff2'),
    url('${publicPath}/fonts/open-sans-v34-latin-600italic.woff') format('woff'),
    url('${publicPath}/fonts/open-sans-v34-latin-600italic.ttf') format('truetype'),
    url('${publicPath}/fonts/open-sans-v34-latin-600italic.svg#OpenSans') format('svg');
  font-display: swap;
}
/* open-sans-700italic - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 700;
  src: url('${publicPath}/fonts/open-sans-v34-latin-700italic.eot');
  src: local(''), url('${publicPath}/fonts/open-sans-v34-latin-700italic.eot?#iefix') format('embedded-opentype'),
    url('${publicPath}/fonts/open-sans-v34-latin-700italic.woff2') format('woff2'),
    url('${publicPath}/fonts/open-sans-v34-latin-700italic.woff') format('woff'),
    url('${publicPath}/fonts/open-sans-v34-latin-700italic.ttf') format('truetype'),
    url('${publicPath}/fonts/open-sans-v34-latin-700italic.svg#OpenSans') format('svg');
  font-display: swap;
}
/* open-sans-800italic - latin */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 800;
  src: url('${publicPath}/fonts/open-sans-v34-latin-800italic.eot');
  src: local(''), url('${publicPath}/fonts/open-sans-v34-latin-800italic.eot?#iefix') format('embedded-opentype'),
    url('${publicPath}/fonts/open-sans-v34-latin-800italic.woff2') format('woff2'),
    url('${publicPath}/fonts/open-sans-v34-latin-800italic.woff') format('woff'),
    url('${publicPath}/fonts/open-sans-v34-latin-800italic.ttf') format('truetype'),
    url('${publicPath}/fonts/open-sans-v34-latin-800italic.svg#OpenSans') format('svg');
  font-display: swap;
}
`,
      }}
    />
  )
}
